// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASIC */
.Login {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Login p:not(.passkey-login-hint):not(.login-step-lead):not(.login-choice-lead):not(.login-choice-hint):not(.top-head) {
  font-size: 22px !important;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 450px !important;
  position: relative;
  padding: 20px 0px 0px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid lightgrey;
}
#formContent .top-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 30px 0 34px;
  margin: 0;
  font-size: 20px !important;
  font-weight: bold;
  color: #1a1a1a;
}
#formContent .top-head .auth-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
#formContent .top-head .auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#formContent .top-head .auth-modal-close mat-icon {
  color: #606060;
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;
}
#formContent .top-head .auth-modal-close:hover mat-icon {
  color: #333;
}
#formContent input {
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 16px;
  background: #fff;
  border: 1px solid lightgray;
}
#formContent input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent button[type=submit],
#formContent button.btn-primary {
  font-family: "Raleway";
  background-color: #5ea1d8;
  font-size: 15px;
  cursor: pointer;
  color: white;
  padding: 10px;
  border-radius: 10px;
  border: none;
}
#formContent button.btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
#formContent .alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  width: 85%;
  margin: 0px auto 1rem;
  font-family: "Raleway";
  font-size: 13px;
}

#formFooter {
  background-color: #f6f6f6;
  background: #fff !important;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#formFooter button {
  font-family: "Raleway";
  background-color: transparent;
  font-size: 15px !important;
  cursor: pointer;
  color: #5ea1d8;
  padding: 10px;
  border-radius: 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  height: auto;
  min-height: unset;
  line-height: 1.25;
  box-sizing: border-box;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

/* Kill Bootstrap .form-control height so fields stay at original size */
#formContent input.form-control {
  height: auto !important;
  min-height: unset !important;
  max-height: none !important;
  padding: 15px 32px !important;
  font-size: 16px !important;
  line-height: 1.25 !important;
  box-sizing: border-box !important;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

@media (max-width: 600px) {
  #formContent .login-actions {
    width: 85%;
    flex-direction: column;
    gap: 12px;
  }
  #formContent .login-actions button {
    width: 100%;
    flex: none;
    min-height: unset;
    padding: 10px;
    font-size: 15px;
  }
}
@media (max-width: 460px) {
  .Login {
    align-items: flex-start;
    box-sizing: border-box;
  }
  .Login > div {
    width: 100%;
    max-width: 100%;
  }
  #formFooter {
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  }
  #formFooter button {
    width: 100%;
    min-height: 44px;
    padding: 12px 16px;
    margin: 0;
  }
  #formContent {
    width: 100% !important;
    max-width: 100%;
    padding: 16px 16px 0;
    box-sizing: border-box;
  }
  #formContent input {
    width: 100%;
    box-sizing: border-box;
  }
  #formContent .alert-danger {
    width: 100% !important;
    margin: 0 0 1rem;
    box-sizing: border-box;
  }
  #formContent .top-head {
    padding: 4px 0 0;
  }
  #formContent .login-actions {
    width: 100%;
    flex-direction: column;
    gap: 12px;
    margin: 16px 0;
  }
  #formContent .login-actions button {
    width: 100%;
    flex: none;
    min-height: unset;
    padding: 10px;
    font-size: 15px;
    line-height: normal;
  }
  #formContent .password-toggle {
    right: 22px;
  }
  #formContent .passkey-help-toggle {
    margin: 0 0 10px;
    padding: 6px 0;
    min-height: 32px;
  }
  #formContent .passkey-login-hint {
    max-width: 100%;
    padding: 0;
    margin: 0 0 12px;
    text-align: left;
  }
  #formContent .passkey-feedback {
    width: 100%;
  }
}
.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent .top-head {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) #formContent input::-webkit-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input::-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-ms-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover mat-icon {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formFooter {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
  border-bottom-color: #5ea1d8 !important;
}

.login-actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
  width: 85%;
  margin: 4px auto 16px;
  box-sizing: border-box;
  border: none !important;
}
.login-actions.fadeIn, .login-actions.fadeIn.second, .login-actions.fadeIn.fourth {
  border: none !important;
}
.login-actions button {
  margin: 0 !important;
  min-height: unset;
  padding: 10px;
  font-size: 15px;
}

.login-email-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 85%;
  margin: 8px auto 14px;
  padding: 8px 14px;
  box-sizing: border-box;
  background: #f6f6f6;
  border: 2px solid #f6f6f6;
  border-radius: 5px;
  text-align: left;
}
.login-email-bar.fadeIn.second {
  border: 2px solid #f6f6f6;
}

.login-email-bar__value {
  font-family: "Raleway", "Poppins", sans-serif;
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  line-height: 1.3;
}

.login-email-bar__edit {
  flex-shrink: 0;
  border: none !important;
  background: transparent !important;
  padding: 0;
  margin: 0 !important;
  min-width: unset !important;
  font-family: "Raleway";
  font-size: 13px !important;
  font-weight: 600;
  color: #5ea1d8 !important;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1;
}

.login-switch-method {
  display: inline-block;
  margin: 0 auto 10px;
  padding: 0;
  border: none !important;
  background: transparent !important;
  font-family: "Raleway";
  font-size: 13px !important;
  font-weight: 500;
  color: #5ea1d8 !important;
  text-decoration: underline;
  cursor: pointer;
  min-width: unset !important;
}
.login-switch-method:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.password-row {
  position: relative;
  display: block;
  width: 100%;
}

.password-row .password-toggle {
  position: absolute;
  right: calc(7.5% + 14px);
  top: 50%;
  transform: translateY(calc(-50% - 8px));
  cursor: pointer;
  color: #64748b;
  font-size: 20px;
  -webkit-user-select: none;
          user-select: none;
  z-index: 2;
}

.password-toggle {
  cursor: pointer;
  color: #64748b;
  font-size: 20px;
  -webkit-user-select: none;
          user-select: none;
  z-index: 2;
}

.passkey-feedback {
  width: 85%;
  margin: 8px auto 14px;
  text-align: left;
  box-sizing: border-box;
}

.passkey-help-toggle {
  display: inline-block;
  margin: 0 0 8px;
  padding: 0;
  border: none !important;
  background: transparent !important;
  font-family: "Raleway";
  font-size: 12px;
  font-weight: 500;
  color: #5ea1d8 !important;
  text-decoration: underline;
  cursor: pointer;
  min-width: unset !important;
  text-align: left;
}
.passkey-help-toggle:hover {
  color: #4a8fc4 !important;
}

.passkey-login-hint {
  font-family: "Raleway";
  font-size: 12px !important;
  line-height: 1.45;
  color: #666;
  margin: 0 0 12px;
  max-width: 100%;
  text-align: left;
  padding: 0;
}

.passkey-error,
#formContent .alert-danger.passkey-error {
  width: 100% !important;
  margin: 0 0 8px !important;
  text-align: left;
  box-sizing: border-box;
}

body.theme-dark .passkey-help-toggle {
  color: #7bbde8 !important;
}
body.theme-dark .passkey-help-toggle:hover {
  color: #9dd0f0 !important;
}

body.theme-dark .passkey-login-hint {
  color: #94a3b8 !important;
}

body.theme-dark .login-email-bar {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .login-email-bar__value {
  color: #e5e7eb !important;
}

body.theme-dark .login-email-bar__edit,
body.theme-dark .login-switch-method {
  color: #7bbde8 !important;
}

body.theme-dark .password-toggle {
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.component.scss"],"names":[],"mappings":"AAAA,UAAA;AAEA;EACE,uBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAEE;EACE,0BAAA;AAAJ;;AAGA;EACE,iBAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kCAAA;EACA,aAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EAEA,uBAAA;EAEA,kBAAA;EACA,qBAAA;EAEA,iDAAA;EACA,kBAAA;EACA,2BAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;AAFJ;AAII;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAFN;AAIM;EACE,qCAAA;AAFR;AAKM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAHR;AAMM;EACE,WAAA;AAJR;AAQE;EACE,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AANJ;AAOI;EACE,wBAAA;EACA,qCAAA;AALN;AAOI;EACE,gBAAA;EACA,qCAAA;AALN;AAOI;EACE,WAAA;EACA,qCAAA;AALN;AAOI;EACE,gBAAA;EACA,qCAAA;AALN;AAQE;;EAEE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AANJ;AAQE;EACE,aAAA;EACA,mBAAA;AANJ;AAQE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AANJ;;AAUA;EACE,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPF;AAQE;EACE,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AANJ;;AAUA,SAAA;AAEA;EACE,cAAA;AARF;;AAWA;EACE,cAAA;EACA,gCAAA;AARF;;AAWA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AATF;;AAYA;;;EAGE,yBAAA;AATF;;AAYA;;;EAOE,sBAAA;AATF;;AAYA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AATF;;AAYA,wEAAA;AACA;EACE,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,iCAAA;AATF;;AAYA;;EAEE,sBAAA;EACA,gCAAA;AATF;;AAYA;;EAEE,cAAA;AATF;;AAYA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAVF;AA0BA;EACE;IACE,UAAA;IAEA,mCAAA;EAXF;EAaA;IACE,UAAA;IAEA,eAAA;EAXF;AACF;AAcA,kCAAA;AAiBA;EACE;IACE,UAAA;EAZF;EAcA;IACE,UAAA;EAZF;AACF;AAeA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAfF;;AAkBA;EAGE,qBAAA;AAfF;;AAkBA;EAGE,qBAAA;EACA,6BAAA;AAfF;;AAkBA;EAGE,qBAAA;EACA,6BAAA;AAfF;;AAkBA;EAGE,mBAAA;EACA,6BAAA;AAfF;;AAkBA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,WAAA;AAfF;;AAkBA,WAAA;AAEA;EACE,aAAA;AAhBF;;AAmBA;EACE,UAAA;AAhBF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EAEI;IACE,UAAA;IACA,sBAAA;IACA,SAAA;EAhBJ;EAkBI;IACE,WAAA;IACA,UAAA;IACA,iBAAA;IACA,aAAA;IACA,eAAA;EAhBN;AACF;AAqBA;EACE;IACE,uBAAA;IACA,sBAAA;EAnBF;EAqBE;IACE,WAAA;IACA,eAAA;EAnBJ;EAuBA;IACE,sBAAA;IACA,QAAA;IACA,aAAA;EArBF;EAuBE;IACE,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,SAAA;EArBJ;EAyBA;IACE,sBAAA;IACA,eAAA;IACA,oBAAA;IACA,sBAAA;EAvBF;EAyBE;IACE,WAAA;IACA,sBAAA;EAvBJ;EA0BE;IACE,sBAAA;IACA,gBAAA;IACA,sBAAA;EAxBJ;EA2BE;IACE,gBAAA;EAzBJ;EA4BE;IACE,WAAA;IACA,sBAAA;IACA,SAAA;IACA,cAAA;EA1BJ;EA4BI;IACE,WAAA;IACA,UAAA;IACA,iBAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;EA1BN;EA8BE;IACE,WAAA;EA5BJ;EA+BE;IACE,gBAAA;IACA,cAAA;IACA,gBAAA;EA7BJ;EAgCE;IACE,eAAA;IACA,UAAA;IACA,gBAAA;IACA,gBAAA;EA9BJ;EAiCE;IACE,WAAA;EA/BJ;AACF;AAmCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAjCF;;AAqCE;EACE,oCAAA;EACA,yBAAA;AAlCJ;AAqCE;EACE,8BAAA;EACA,iDAAA;EACA,oDAAA;EACA,yBAAA;AAnCJ;AAqCI;EACE,yBAAA;AAnCN;AAsCI;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AApCN;AAsCM;EAA+B,0CAAA;AAnCrC;AAoCM;EAAsB,0CAAA;AAjC5B;AAkCM;EAA0B,0CAAA;AA/BhC;AAgCM;EAAqB,0CAAA;AA7B3B;AAgCI;EACE,yBAAA;AA9BN;AAiCI;EACE,sDAAA;AA/BN;AAkCI;EACE,yBAAA;AAhCN;AAoCE;EACE,8BAAA;EACA,qDAAA;AAlCJ;AAqCE;;EAEE,oCAAA;EACA,yBAAA;EACA,iDAAA;AAnCJ;AAsCE;;EAEE,oCAAA;EACA,uCAAA;AApCJ;;AAwCA;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;AArCF;AAuCE;EAGE,uBAAA;AAvCJ;AA0CE;EACE,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAxCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAzCF;AA2CE;EACE,yBAAA;AAzCJ;;AA6CA;EACE,6CAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AA1CF;;AA6CA;EACE,cAAA;EACA,uBAAA;EACA,kCAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,2BAAA;AA1CF;AA4CE;EACE,aAAA;EACA,mBAAA;AA1CJ;;AA8CA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;AA3CF;;AA8CA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AA3CF;;AA8CA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AA3CF;;AA8CA;EACE,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AA3CF;;AA8CA;EACE,qBAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;AA3CF;AA6CE;EACE,yBAAA;AA3CJ;;AA+CA;EACE,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AA5CF;;AA+CA;;EAEE,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;AA8CE;EACE,yBAAA;AA5CJ;;AAgDA;EACE,yBAAA;AA7CF;;AAgDA;EACE,8BAAA;EACA,iDAAA;AA7CF;;AAgDA;EACE,yBAAA;AA7CF;;AAgDA;;EAEE,yBAAA;AA7CF;;AAgDA;EACE,cAAA;AA7CF","sourcesContent":["/* BASIC */\n\n.Login {\n  background-color: white;\n  // min-height: 89vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  p:not(.passkey-login-hint):not(.login-step-lead):not(.login-choice-lead):not(.login-choice-hint):not(.top-head) {\n    font-size: 22px !important;\n  }\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 30px;\n\n  width: 450px !important;\n\n  position: relative;\n  padding: 20px 0px 0px;\n  -webkit-box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  text-align: center;\n  border: 1px solid lightgrey;\n  \n  .top-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 30px 0 34px;\n    margin: 0;\n    font-size: 20px !important;\n    font-weight: bold;\n    color: #1a1a1a;\n    \n    .auth-modal-close {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: none;\n      border-radius: 50%;\n      margin-left: auto;\n      margin-right: 0;\n      padding: 0;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n      \n      mat-icon {\n        color: #606060;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        transition: color 0.2s ease;\n      }\n      \n      &:hover mat-icon {\n        color: #333;\n      }\n    }\n  }\n  input {\n    margin-bottom: 20px;\n    color: rgba(0, 0, 0, 0.54) !important;\n    font-size: 16px;\n    background: #fff;\n    border: 1px solid lightgray;\n    &::-webkit-input-placeholder {\n      /* Chrome/Opera/Safari */\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &::-moz-placeholder {\n      /* Firefox 19+ */\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-ms-input-placeholder {\n      /* IE 10+ */\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-moz-placeholder {\n      /* Firefox 18- */\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n  }\n  button[type=\"submit\"],\n  button.btn-primary {\n    font-family: \"Raleway\";\n    background-color: #5ea1d8;\n    font-size: 15px;\n    cursor: pointer;\n    color: white;\n    padding: 10px;\n    border-radius: 10px;\n    border: none;\n  }\n  button.btn-primary:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n  .alert-danger {\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n    width: 85%;\n    margin: 0px auto 1rem;\n    font-family: \"Raleway\";\n    font-size: 13px;\n  }\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  background: #fff !important;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  button {\n    font-family: \"Raleway\";\n    background-color: transparent;\n    font-size: 15px !important;\n    cursor: pointer;\n    color: #5ea1d8;\n    padding: 10px;\n    border-radius: 10px;\n  }\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  height: auto;\n  min-height: unset;\n  line-height: 1.25;\n  box-sizing: border-box;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\n/* Kill Bootstrap .form-control height so fields stay at original size */\n#formContent input.form-control {\n  height: auto !important;\n  min-height: unset !important;\n  max-height: none !important;\n  padding: 15px 32px !important;\n  font-size: 16px !important;\n  line-height: 1.25 !important;\n  box-sizing: border-box !important;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n@media (max-width: 600px) {\n  #formContent {\n    .login-actions {\n      width: 85%;\n      flex-direction: column;\n      gap: 12px;\n\n      button {\n        width: 100%;\n        flex: none;\n        min-height: unset;\n        padding: 10px;\n        font-size: 15px;\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .Login {\n    align-items: flex-start;\n    box-sizing: border-box;\n\n    & > div {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n\n  #formFooter {\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px;\n\n    button {\n      width: 100%;\n      min-height: 44px;\n      padding: 12px 16px;\n      margin: 0;\n    }\n  }\n\n  #formContent {\n    width: 100% !important;\n    max-width: 100%;\n    padding: 16px 16px 0;\n    box-sizing: border-box;\n\n    input {\n      width: 100%;\n      box-sizing: border-box;\n    }\n\n    .alert-danger {\n      width: 100% !important;\n      margin: 0 0 1rem;\n      box-sizing: border-box;\n    }\n\n    .top-head {\n      padding: 4px 0 0;\n    }\n\n    .login-actions {\n      width: 100%;\n      flex-direction: column;\n      gap: 12px;\n      margin: 16px 0;\n\n      button {\n        width: 100%;\n        flex: none;\n        min-height: unset;\n        padding: 10px;\n        font-size: 15px;\n        line-height: normal;\n      }\n    }\n\n    .password-toggle {\n      right: 22px;\n    }\n\n    .passkey-help-toggle {\n      margin: 0 0 10px;\n      padding: 6px 0;\n      min-height: 32px;\n    }\n\n    .passkey-login-hint {\n      max-width: 100%;\n      padding: 0;\n      margin: 0 0 12px;\n      text-align: left;\n    }\n\n    .passkey-feedback {\n      width: 100%;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n    color: #e5e7eb !important;\n\n    .top-head {\n      color: #e5e7eb !important;\n    }\n\n    input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n\n      &::-webkit-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &::-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-ms-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n    }\n\n    .auth-modal-close mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .auth-modal-close:hover {\n      background-color: rgba(255, 255, 255, 0.08) !important;\n    }\n\n    .auth-modal-close:hover mat-icon {\n      color: #e5e7eb !important;\n    }\n  }\n\n  #formFooter {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n    border-bottom-color: #5ea1d8 !important;\n  }\n}\n\n.login-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n  width: 85%;\n  margin: 4px auto 16px;\n  box-sizing: border-box;\n  border: none !important;\n\n  &.fadeIn,\n  &.fadeIn.second,\n  &.fadeIn.fourth {\n    border: none !important;\n  }\n\n  button {\n    margin: 0 !important;\n    min-height: unset;\n    padding: 10px;\n    font-size: 15px;\n  }\n}\n\n.login-email-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 85%;\n  margin: 8px auto 14px;\n  padding: 8px 14px;\n  box-sizing: border-box;\n  background: #f6f6f6;\n  border: 2px solid #f6f6f6;\n  border-radius: 5px;\n  text-align: left;\n\n  &.fadeIn.second {\n    border: 2px solid #f6f6f6;\n  }\n}\n\n.login-email-bar__value {\n  font-family: \"Raleway\", \"Poppins\", sans-serif;\n  font-size: 14px !important;\n  color: rgba(0, 0, 0, 0.65);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  line-height: 1.3;\n}\n\n.login-email-bar__edit {\n  flex-shrink: 0;\n  border: none !important;\n  background: transparent !important;\n  padding: 0;\n  margin: 0 !important;\n  min-width: unset !important;\n  font-family: \"Raleway\";\n  font-size: 13px !important;\n  font-weight: 600;\n  color: #5ea1d8 !important;\n  text-decoration: underline;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.login-switch-method {\n  display: inline-block;\n  margin: 0 auto 10px;\n  padding: 0;\n  border: none !important;\n  background: transparent !important;\n  font-family: \"Raleway\";\n  font-size: 13px !important;\n  font-weight: 500;\n  color: #5ea1d8 !important;\n  text-decoration: underline;\n  cursor: pointer;\n  min-width: unset !important;\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.password-row {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.password-row .password-toggle {\n  position: absolute;\n  right: calc(7.5% + 14px);\n  top: 50%;\n  transform: translateY(calc(-50% - 8px));\n  cursor: pointer;\n  color: #64748b;\n  font-size: 20px;\n  user-select: none;\n  z-index: 2;\n}\n\n.password-toggle {\n  cursor: pointer;\n  color: #64748b;\n  font-size: 20px;\n  user-select: none;\n  z-index: 2;\n}\n\n.passkey-feedback {\n  width: 85%;\n  margin: 8px auto 14px;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.passkey-help-toggle {\n  display: inline-block;\n  margin: 0 0 8px;\n  padding: 0;\n  border: none !important;\n  background: transparent !important;\n  font-family: \"Raleway\";\n  font-size: 12px;\n  font-weight: 500;\n  color: #5ea1d8 !important;\n  text-decoration: underline;\n  cursor: pointer;\n  min-width: unset !important;\n  text-align: left;\n\n  &:hover {\n    color: #4a8fc4 !important;\n  }\n}\n\n.passkey-login-hint {\n  font-family: \"Raleway\";\n  font-size: 12px !important;\n  line-height: 1.45;\n  color: #666;\n  margin: 0 0 12px;\n  max-width: 100%;\n  text-align: left;\n  padding: 0;\n}\n\n.passkey-error,\n#formContent .alert-danger.passkey-error {\n  width: 100% !important;\n  margin: 0 0 8px !important;\n  text-align: left;\n  box-sizing: border-box;\n}\n\nbody.theme-dark .passkey-help-toggle {\n  color: #7bbde8 !important;\n\n  &:hover {\n    color: #9dd0f0 !important;\n  }\n}\n\nbody.theme-dark .passkey-login-hint {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .login-email-bar {\n  background: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\nbody.theme-dark .login-email-bar__value {\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .login-email-bar__edit,\nbody.theme-dark .login-switch-method {\n  color: #7bbde8 !important;\n}\n\nbody.theme-dark .password-toggle {\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
